// App.js
import { useEffect, useState } from "react";
// import "./App.css";
import "../etlsecound.css";
import hdfcs from '../../../../assets/images/banks/thermax.png';


function Annux5() 
{
  

  return (
  <div>
    <table className="table1">
    <tr className="bold">
        <td colSpan={11}>Debit Credit Note or any other difference</td>
        
    </tr>
    <br></br>
    <tr className="fontcolor">
        <td>DATE</td>
        <td>PARTICULARS</td>
        <td>VCH TYPE</td>
        <td>VCH NO.</td>
        <td>Cr/Dr</td>
        <td>DEBIT</td>
        <td>CREDIT</td>
        <td>Remarks</td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027487-1862443-TDS-CM-842898</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1375</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027672-1872381-TDS-CM-841110</td>
        <td></td>
        <td></td>
        <td></td>
        <td> 93.00 </td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027675-1872383-TDS-CM-844793</td>
        <td></td>
        <td></td>
        <td></td>
        <td> 93.00 </td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027439-1860517-TDS-CM-844262</td>
        <td></td>
        <td></td>
        <td></td>
        <td> 2,062.00 </td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027488-1862444-TDS-CM-845282</td>
        <td></td>
        <td></td>
        <td></td>
        <td> 687.00 </td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027486-1862442-TDS-CM-846977</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1375</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>12/31/21</td>
        <td>ERS-4000027673-1872382-TDS-CM-846971</td>
        <td></td>
        <td></td>
        <td></td>
        <td>93</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>1/14/22</td>
        <td>ERS-4000027668-1872378-TDS-CM-851638</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1382</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>1/14/22</td>
        <td>ERS-4000027670-1872379-TDS-CM-851654</td>
        <td></td>
        <td></td>
        <td></td>
        <td>326</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>1/14/22</td>
        <td>ERS-4000027671-1872380-TDS-CM-851660</td>
        <td></td>
        <td></td>
        <td></td>
        <td>326</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>1/14/22</td>
        <td>ERS-4000028002-1887105-TDS-CM-851725</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1152</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>1/14/22</td>
        <td>ERS-4000027985-1887104-TDS-CM-851713</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1302</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>2/5/22</td>
        <td>ERS-4000028069-1888025-TDS-CM-862208</td>
        <td></td>
        <td></td>
        <td></td>
        <td>781</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/4/22</td>
        <td>ERS-4000028325-1899878-TDS-CM-877309</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1215</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/16/22</td>
        <td>ERS-4000028607-1912701-TDS-CM-884162</td>
        <td></td>
        <td></td>
        <td></td>
        <td>2753</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/18/22</td>
        <td>ERS-4000028544-1909821-TDS-CM-886242</td>
        <td></td>
        <td></td>
        <td></td>
        <td>2753</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/21/22</td>
        <td>ERS-4000028647-1913517-TDS-CM-887043</td>
        <td></td>
        <td></td>
        <td></td>
        <td> 1,927.00 </td>
        <td> -   </td>
        <td></td>
    </tr>
    <tr>
        <td>3/21/22</td>
        <td>ERS-4000028646-1913516-TDS-CM-887050</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1927</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/21/22</td>
        <td>ERS-4000028649-1913519-TDS-CM-887027</td>
        <td></td>
        <td></td>
        <td></td>
        <td>2753</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/24/22</td>
        <td>ERS-4000028648-1913518-TDS-CM-889303</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1927</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/28/22</td>
        <td>ERS-5000014989-1925419-TDS-CM-892671</td>
        <td></td>
        <td></td>
        <td></td>
        <td>9</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>91 MSME Interest 2020-2021-TDS-CM-895608</td>
        <td></td>
        <td></td>
        <td></td>
        <td>3103</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>ERS-5000015144-1933076-TDS-CM-901028</td>
        <td></td>
        <td></td>
        <td></td>
        <td>22</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>Q4 94Q CORRECTION-TDS-CM-905493</td>
        <td></td>
        <td></td>
        <td></td>
        <td>87</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>08-PROV-21.22_PO_103</td>
        <td></td>
        <td></td>
        <td></td>
        <td>3248.17</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>08-PROV-21.22_PO_29</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1786.5</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>08-PROV-21.22_PO_278</td>
        <td></td>
        <td></td>
        <td></td>
        <td>1599.39</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>08-PROV-21.22_PO_254</td>
        <td></td>
        <td></td>
        <td></td>
        <td>204.85</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>08-PROV-21.22_PO_529</td>
        <td></td>
        <td></td>
        <td></td>
        <td>3248.17</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>3/31/22</td>
        <td>95114497</td>
        <td></td>
        <td></td>
        <td></td>
        <td>31034</td>
        <td></td>
        <td></td>
    </tr>
    <tr>
        <td>44561</td>
        <td>ERS-4000027487-1862443-RTN-TDS-SI-842899</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>963</td>
        <td></td>
    </tr>
    <tr>
        <td>44561</td>
        <td>ERS-4000027488-1862444-RTN-TDS-SI-845285</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>481</td>
        <td></td>
    </tr>
    <tr>
        <td>44561</td>
        <td>ERS-4000027439-1860517-RTN-TDS-SI-844263</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1443</td>
        <td></td>
    </tr>
    <tr>
        <td>44561</td>
        <td>ERS-4000027486-1862442-RTN-TDS-SI-846978</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>567</td>
        <td></td>
    </tr>
    <tr>
        <td>44570</td>
        <td>ERS-4000027486-1862442-RTN-TDS-SI-846992</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>396</td>
        <td></td>
    </tr>
    <tr>
        <td>44575</td>
        <td>ERS-4000028002-1887105-RTN-TDS-SI-851726</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>806</td>
        <td></td>
    </tr>
    <tr>
        <td>44575</td>
        <td>ERS-4000027668-1872378-RTN-TDS-SI-851640</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>967</td>
        <td></td>
    </tr>
    <tr>
        <td>44575</td>
        <td>ERS-4000027985-1887104-RTN-TDS-SI-851714</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>911</td>
        <td></td>
    </tr>
    <tr>
        <td>44597</td>
        <td>ERS-4000028069-1888025-RTN-TDS-SI-862209</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>547</td>
        <td></td>
    </tr>
    <tr>
        <td>44624</td>
        <td>ERS-4000028325-1899878-RTN-TDS-SI-877311</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>851</td>
        <td></td>
    </tr>
    <tr>
        <td>44636</td>
        <td>ERS-4000028607-1912701-RTN-TDS-SI-884164</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1927</td>
        <td></td>
    </tr>
    <tr>
        <td>44638</td>
        <td>ERS-4000028544-1909821-RTN-TDS-SI-886244</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1927</td>
        <td></td>
    </tr>
    <tr>
        <td>44641</td>
        <td>ERS-4000028647-1913517-RTN-TDS-SI-887044</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1349</td>
        <td></td>
    </tr>
    <tr>
        <td>44641</td>
        <td>ERS-4000028646-1913516-RTN-TDS-SI-887051</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1349</td>
        <td></td>
    </tr>
    <tr>
        <td>44641</td>
        <td>ERS-4000028649-1913519-RTN-TDS-SI-887028</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1927</td>
        <td></td>
    </tr>
    <tr>
        <td>44644</td>
        <td>ERS-4000028648-1913518-RTN-TDS-SI-889304</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>1349</td>
        <td></td>
    </tr>
    <tr>
        <td>44650</td>
        <td>91 MSME Interest 2020-2021</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>31034</td>
        <td></td>
    </tr>
    <tr>
        <td>44651</td>
        <td>95114497</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>3103</td>
        <td></td>
    </tr>
    <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>70644.08</td>
        <td>51897</td>
        <td></td>
    </tr>
    <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>18747.08</td>
    </tr>
</table>
  </div>
  )
}



export default Annux5;